import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button, Badge } from 'react-bootstrap';

const Navigation = () => {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    // Remove tokens from localStorage
    localStorage.removeItem('restaurantToken');
    localStorage.removeItem('managerToken');
    localStorage.removeItem('superAdminToken');
    // Redirect to home page
    navigate('/');
  };

  // Check if restaurant or manager is logged in (mutually exclusive in UI)
  const hasOwner = !!localStorage.getItem('restaurantToken');
  const hasManagerRaw = !!localStorage.getItem('managerToken');
  const hasSuperAdminRaw = !!localStorage.getItem('superAdminToken');

  // Superadmin takes precedence in UI when logged in
  const isSuperAdminLoggedIn = hasSuperAdminRaw;
  const isRestaurantLoggedIn = !isSuperAdminLoggedIn && hasOwner;
  const isManagerLoggedIn = !isSuperAdminLoggedIn && !hasOwner && hasManagerRaw;

  return (
    <Navbar className="modern-navbar" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="navbar-brand-custom">
          <i className="bi bi-qr-code me-2"></i>
          <span className="brand-text">QR Menu</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-toggle-custom" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto nav-links-custom">
            {isSuperAdminLoggedIn ? (
              // Superadmin-only navigation
              <>
                <Nav.Link as={Link} to="/superadmin" className="nav-link-custom">
                  <i className="bi bi-shield-check me-1"></i>
                  Панель суперадмина
                </Nav.Link>
              </>
            ) : isRestaurantLoggedIn ? (
              // Owner-only navigation
              <>
                <Nav.Link as={Link} to="/admin" className="nav-link-custom">
                  <i className="bi bi-speedometer2 me-1"></i>
                  Панель управления
                </Nav.Link>
                <Nav.Link as={Link} to="/admin/menu" className="nav-link-custom">
                  <i className="bi bi-menu-button-wide me-1"></i>
                  Управление меню
                </Nav.Link>
                <Nav.Link as={Link} to="/admin/orders" className="nav-link-custom">
                  <i className="bi bi-cart-check me-1"></i>
                  Заказы
                  <Badge bg="warning" className="ms-1">Live</Badge>
                </Nav.Link>
                <Nav.Link as={Link} to="/admin/promotions" className="nav-link-custom">
                  <i className="bi bi-percent me-1"></i>
                  Акции и скидки
                </Nav.Link>
                <Nav.Link as={Link} to="/admin/stats" className="nav-link-custom">
                  <i className="bi bi-graph-up me-1"></i>
                  Статистика
                </Nav.Link>
                <Nav.Link as={Link} to="/admin/managers" className="nav-link-custom">
                  <i className="bi bi-people me-1"></i>
                  Менеджеры
                </Nav.Link>
              </>
            ) : isManagerLoggedIn ? (
              // Manager-only navigation
              <>
                <Nav.Link as={Link} to="/manager/orders-page" className="nav-link-custom">
                  <i className="bi bi-person-badge me-1"></i>
                  Панель менеджера
                </Nav.Link>
              </>
            ) : (
              // Guest navigation
              <>
                <Nav.Link as={Link} to="/login" className="nav-link-custom">
                  <i className="bi bi-building me-1"></i>
                  Вход владельца
                </Nav.Link>
                <Nav.Link as={Link} to="/manager/login" className="nav-link-custom">
                  <i className="bi bi-person me-1"></i>
                  Вход менеджера
                </Nav.Link>
                <Nav.Link as={Link} to="/superadmin/login" className="nav-link-custom">
                  <i className="bi bi-shield me-1"></i>
                  Вход суперадмина
                </Nav.Link>
              </>
            )}
          </Nav>
          
          <Nav className="nav-actions-custom">
            {(isRestaurantLoggedIn || isManagerLoggedIn || isSuperAdminLoggedIn) ? (
              <Button 
                variant="outline-light" 
                onClick={handleLogout}
                className="logout-btn-custom"
              >
                <i className="bi bi-box-arrow-right me-1"></i>
                Выйти
              </Button>
            ) : (
              <Button 
                as={Link} 
                to="/" 
                variant="primary"
                className="home-btn-custom"
              >
                <i className="bi bi-house me-1"></i>
                На главную
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;